// Datos del catálogo de reportes. `runReport` es SÍNCRONA: devuelve el archivo ya generado, y al
// terminar se invalida el catálogo para que la corrida aparezca en el log.
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
    reportsApi,
    type ReportFormat,
    type ReportPeriod,
} from '@/api/services/retail-wizard/backoffice';

const KEY = ['retail-admin', 'reportes'] as const;

export function useReportCatalog() {
    return useQuery({
        queryKey: [...KEY, 'catalog'],
        queryFn: () => reportsApi.getCatalog(),
        staleTime: 60_000,
    });
}

export function useRunReport() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: ({
            reportId,
            format,
            period,
        }: {
            reportId: string;
            format: ReportFormat;
            period?: ReportPeriod;
        }) => reportsApi.runReport(reportId, format, period),
        onSuccess: () => {
            // La corrida queda registrada en el log —haya salido bien o mal—, así que se refresca.
            void qc.invalidateQueries({ queryKey: KEY });
        },
    });
}
